import { Box,Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Text, Flex } from '@chakra-ui/react'
import React from 'react'
import {motion} from 'framer-motion'
export const Work = () => {
  return (
    <motion.div  initial={{ opacity: 0 }}
    whileInView={{ opacity: 1,transition:{duration: 1}}}>
    <Flex name='Work'>
      <Accordion  textAlign={'center'} border={'1px solid black'}   allowMultiple width={{sm:'300px',md:'600px',ls:'600px', lg:'600px',xl:'600px'}} margin='auto'>
        <Text as={'h2'} fontSize={'1.5rem'} fontWeight={'900'}>Si trabajamos juntos vas a...</Text>
  <AccordionItem margin={'1rem'}>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        <Text fontWeight={'900'} color='#000' fontSize={{sm:'1rem'}}>
          Mejorar la imagen de tu marca:
        </Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    <AccordionPanel pb={4}>
    Actualmente, antes de consumir un producto o servicio, es
normal buscarlo en las redes sociales. Si al hacerlo, el usuario
encuentra pocos o nulos resultados, la reacción no es positiva.
Las redes sociales son una cara importante hoy en día..
    </AccordionPanel>
  </AccordionItem>

  <AccordionItem margin={'1rem'}>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        <Text fontWeight={'900'} color='#000'>
          Brindar mejor atención al cliente:
        </Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    <AccordionPanel pb={4}>
    Cada vez son más los consumidores que eligen las redes para
contactarse con una marca.
Estar activo y responder con rapidéz hace que no pierdas
oportunidades de negocios
    </AccordionPanel>
  </AccordionItem>
  
  <AccordionItem margin={'1rem'}>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        <Text fontWeight={'900'} color='#000'>

          Distribuir el contenido y aportar calidad en los mismos:
        </Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    <AccordionPanel pb={4}>
    Es importante estar activo en distintas plataformas así nos
tienen presentes.
Aunque no postees todos los días, las publicaciones deben ser
de calidad. Hay estrategias de comunicación las cuales sirven
para encontrar los temas que encajen con tu marca. 
    </AccordionPanel>
  </AccordionItem>

  <AccordionItem margin={'1rem'}>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        <Text fontWeight={'900'} color='#000'>
        Aumentar afinidad con la audiencia
        </Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    <AccordionPanel pb={4}>
    Las redes son espacios útiles para acercarnos, contar historias,
deleitar a la comunidad y hacer visible la marca.
Es una especie de vidriera más, la cual hay que cuidar.
    </AccordionPanel>
  </AccordionItem>

  <AccordionItem margin={'1rem'}>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
          <Text fontWeight={'900'} color='#000'>
            Observar con inteligencia las métricas:            
          </Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    <AccordionPanel pb={4}>
    No tiene sentido publicar contenido sin un objetivo alcanzable.
Planteándolos, podemos crear un calendario de publicaciones
para obtener resultados favorables.
Mirando los indicadores correctos podemos saber si está funcionando y conocer al público. 
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem margin={'1rem'}>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        <Text fontWeight={'900'} color='#000'>
            Multiplicar alcance y fidelizar clientes:
        </Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    <AccordionPanel pb={4}>
    La mejor tribuna para que nos vean es la digital.
Hay maneras inteligentes de mostrarnos asi nos eligen una y
otra vez.
    </AccordionPanel>
  </AccordionItem>
</Accordion>
</Flex>
</motion.div>

  )
}
